// R2 display navigation only. A deliberate revisit must not become a new
// learning checkpoint or edit authored evidence; the existing state_json
// remains the source of truth for Continue Adventure.
export const copyActivityCursors = (cursor) => ({
  ...(cursor || {}),
  r2BeatCursors: { ...(cursor?.r2BeatCursors || {}) },
});

export const startStepFromBeginning = (cursor, stepId) => {
  if (!cursor || !stepId) return;
  cursor[stepId] = 0;
  Object.keys(cursor.r2BeatCursors || {}).forEach((key) => {
    if (key.startsWith(`${stepId}:`)) cursor.r2BeatCursors[key] = 0;
  });
};

export const startActivityFromBeginning = (cursor, stepId, activityId) => {
  if (!cursor || !stepId || !activityId) return;
  if (!cursor.r2BeatCursors) cursor.r2BeatCursors = {};
  cursor.r2BeatCursors[`${stepId}:${activityId}`] = 0;
};

export const planStepMove = ({ currentIndex, nextIndex, checkpointIndex,
  reviewing = false, explicitSelection = false }) => {
  const isReview = explicitSelection || nextIndex < currentIndex ||
    (reviewing && nextIndex <= checkpointIndex);
  return {
    reviewing: isReview,
    checkpointIndex: isReview ? checkpointIndex : Math.max(checkpointIndex, nextIndex),
  };
};

// If a child replays old work all the way past their real saved point, their
// subsequent work becomes the new checkpoint. Merely reopening completed
// activities or moving *up to* the saved part never replaces it.
export const hasAdvancedPastCheckpoint = ({ viewIndex, checkpointIndex, stepId,
  savedCursors, viewCursors, activities }) => {
  if (viewIndex > checkpointIndex) return true;
  if (viewIndex < checkpointIndex || !stepId || !activities?.length) return false;
  const oldActivity = Number(savedCursors?.[stepId] || 0);
  const newActivity = Number(viewCursors?.[stepId] || 0);
  if (newActivity !== oldActivity) return newActivity > oldActivity;
  const activityId = activities[oldActivity]?.id;
  if (!activityId) return false;
  const key = `${stepId}:${activityId}`;
  return Number(viewCursors?.r2BeatCursors?.[key] || 0) >
    Number(savedCursors?.r2BeatCursors?.[key] || 0);
};
